import { LogoContainer } from "./components/LogoContainer.js";
import { NotificationContainer } from "./components/NotificationContainer.js";
import { FooterContainer } from "./components/FooterContainer.js";
import { ProductContainerData } from "./components/ProductContainer.js";
import { ProductListContainer } from "./components/ProductListContainer.js";
import { UtcInfoContainet } from "./components/UtcInfoContainet.js";

import css from "./styles.js";

export interface SummaryTemplateData {
  shop: string;
  logoHeader: string;
  logoFooter: string;
  notificationIcon: string;
  events: ProductContainerData[];
  stockType: string;
  frequencyType?: string;
  summaryPdfLink?: string;
  summaryCsvLink?: string;
  summaryXlsxLink?: string;

  outOfStockPdfLink?: string;
  lowOnStockPdfLink?: string;
  backInStockPdfLink?: string;

  outOfStockCsvLink?: string;
  lowOnStockCsvLink?: string;
  backInStockCsvLink?: string;

  outOfStockXlsxLink?: string;
  lowOnStockXlsxLink?: string;
  backInStockXlsxLink?: string;
  createdAt: string;
  locationInfo?: string; // "All locations" or "Selected locations"
}

const SummaryTemplate = (data: SummaryTemplateData) => `
  <html>
    <head>
    <meta charset="utf-8">
    ${css}
    </head>
    <body style="font-family: sans-serif;">
      <div class="summary-template--wrapper">
        ${LogoContainer(data.logoHeader)}
        ${NotificationContainer(
          data.shop,
          data.notificationIcon,
          `<span style="color:#6E5BEA;">${data.frequencyType}</span> Action Summary`,
          data.createdAt,
          `<div style="font-size: 14px;max-width: 75%;font-weight:400;">You'll find a list of products that were updated in the last period along with the action that was taken.</div>${data.locationInfo ? `<div style="font-size: 12px;margin-top: 8px;color: #666;font-weight:400;">Monitoring: ${data.locationInfo}</div>` : ''}`,
          data.summaryPdfLink, 
          data.summaryCsvLink, 
          data.summaryXlsxLink,
        )}
        ${[
          ProductListContainer(
            data.events.filter(({ stockType }) => stockType === "PRODUCTS_ACTION_HIDE" || stockType === "OUT_STOCK"), 
            "Out of Stock", 
            data.outOfStockPdfLink,
            data.outOfStockCsvLink,
            data.outOfStockXlsxLink,
          ),
          ProductListContainer(
            data.events.filter(({ stockType }) => stockType === "PRODUCTS_ACTION_PUSH_DOWN" || stockType === "LOW_STOCK"), 
            "Low on Stock",
            data.lowOnStockPdfLink,
            data.lowOnStockCsvLink,
            data.lowOnStockXlsxLink,
          ),
          ProductListContainer(
            data.events.filter(({ stockType }) => stockType === "BACK_STOCK"), 
            "Back in Stock",
            data.backInStockPdfLink,
            data.backInStockCsvLink,
            data.backInStockXlsxLink,
          ),
        ].sort((A, B)=>B.length - A.length).reduce((acc, value, index)=>{
          if(index < 2) {
            acc.push(...[value, `<div style="width:100%;margin-bottom: 30px;height:2px;background: linear-gradient(60deg, rgba(3, 198, 230, 0.3) 0.63%, rgba(76, 99, 241, 0.3) 20.38%, rgba(110, 91, 234, 0.3) 40.13%, rgba(180, 104, 209, 0.3) 59.88%, rgba(217, 124, 194, 0.3) 79.62%, rgba(241, 137, 184, 0.3) 99.37%);"></div>`]);
          } else {
            acc.push(value);
          }
          return acc;
        }, []).join("")}
        ${UtcInfoContainet()}
      </div>
      ${FooterContainer(data.logoFooter, new Date().getFullYear())}
    </body>
  </html>
`;

export default SummaryTemplate;